import { render, staticRenderFns } from "./EditCmsComponent.vue?vue&type=template&id=4a3f8fce"
import script from "./EditCmsComponent.vue?vue&type=script&lang=js"
export * from "./EditCmsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports